
define(
	'Tavanoteam.FrequentlyBoughtTogether.FrequentlyBoughtTogether'
,   [
		'Tavanoteam.FrequentlyBoughtTogether.FrequentlyBoughtTogether.View'

		,	'Backbone'
		,	'Utils'
		,	'jQuery'
		,	'underscore'
	]
,   function (
		FrequentlyBoughtTogetherView

		,	Backbone
		,	Utils
		,	jQuery
		,	_
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{
			// using the 'Layout' component we add a new child view inside the 'Header' existing view 
			// (there will be a DOM element with the HTML attribute data-view="Header.Logo")
			// more documentation of the Extensibility API in
			// https://system.netsuite.com/help/helpcenter/en_US/APIs/SuiteCommerce/Extensibility/Frontend/index.html
			
			/** @type {LayoutComponent} */
			var layout = container.getComponent('Layout');
			var environment = container.getComponent('Environment');
			var pdp = container.getComponent('PDP');
			
			//Get Minimim Correlation Value
			var getMinimumCorrelation = environment.getConfig('TTFrequentlyBoughtTogether.minimumCorrelation');
			
			//Get Maximum Number of Correlated Items
			var getMaximumNumber = environment.getConfig('TTFrequentlyBoughtTogether.maximumCorrelatedItems');

			if (getMinimumCorrelation && getMaximumNumber) {

				if(pdp) {

					pdp.addChildView('FrequentlyBoughtTogether.Items', function() {
						return new FrequentlyBoughtTogetherView({ container: container });
					});

				}

			}

		}
				
	};
});
